(function() {
    'use strict';
    angular.module('app')
        .controller('NetworkEffectController', NetworkEffectController);
    NetworkEffectController.$inject = ['$q', '$rootScope', '$uibModal', 'scrollToForm', 'CarrierSettingsTableService', 'ClientsNetworkTable', 'SharedCarrierTableService', 'SharedServicesTableService', 'Carrier', 'ClientService', '$timeout'];
    function NetworkEffectController($q, $rootScope, $uibModal, scrollToForm, CarrierSettingsTableService, ClientsNetworkTable, SharedCarrierTableService, SharedServicesTableService, Carrier, ClientService, $timeout){
        let vm = this, carriers = [], services = [];
        const defaultProfileProps = {
            viewProfile,
            exitViewMode
        };
        const clientBridge = {
            setCompany
        };
        let CarrierSettingsTable = null, mappedSettings = null;
        vm.clientsNetworkTable = new ClientsNetworkTable(clientBridge).tableData;
        vm.companies = [];
        vm.searchForCompany = searchForCompany;
        vm.onCompanySelect = onCompanySelect;
        vm.serviceProfile = angular.copy(defaultProfileProps);
        vm.carrierProfile = angular.copy(defaultProfileProps);
        vm.viewRates = viewRates;
        (()=>{
            getCarriers().then(function () {
                if(!$rootScope.GlobalProfile.company.id === 1)
                setCompany($rootScope.GlobalProfile.company)
            });
        })();
        function getCarriers() {
            var defer = $q.defer();
            Carrier.getCarriers(function(data) {
                carriers = data
                defer.resolve(data);
            }, function(err) {
                console.log(err);
                defer.reject(err);
            }).getServices((data)=>{
                services = data;
            });
            return defer.promise;
        }
        function searchForCompany(select) {
            if(!select.open){
                return false;
            }
            vm.searching = true;
            ClientService.Company.getAll(data=>{
                vm.companies = data.content;
                vm.searching = false;
            },err=>{
                toastr.error('Error', err);
                vm.searching = false;
            },{name: select.search.name, size: 30, sort: 'name,desc'});
        }
        function onCompanySelect(company) {
            vm.sharedServicesTableService = null;
            $timeout(()=>{
                vm.sharedCarrierTableService = new SharedCarrierTableService(carriers, vm.carrierProfile).tableData;
                vm.sharedServicesTableService = new SharedServicesTableService(services, vm.serviceProfile).tableData;
            });
        }
        function viewProfile(item) {
            angular.extend(this, item);
            this.viewMode = true;
            this.settingsTable = null;
            $timeout(() => {
                buildProfile(this);
            });
        }
        function buildProfile(item) {
            const isCarrierProfile = !item.carrierProfile;
            const parentSettings = isCarrierProfile ? item.carrier.settings : item.service.settings;
            const settings = item.settings;
            CarrierSettingsTable = new CarrierSettingsTableService(getMappedSettings(parentSettings, settings));
            item.settingsTable = CarrierSettingsTable.buildSettings();
            console.log(item.settingsTable);
        }
        function getMappedSettings(carrierSettings, profileSettings) {
            let options = [];
            angular.forEach(carrierSettings, carrierSetting => {
                const matchSetting = profileSettings ? profileSettings.find(profileSetting => profileSetting.name === carrierSetting.name) : null;
                options.push({
                    name: matchSetting ? matchSetting.name : carrierSetting.name,
                    description: matchSetting ? matchSetting.description : carrierSetting.description,
                    value: matchSetting ? matchSetting.value : carrierSetting.value,
                    options: carrierSetting && carrierSetting.option ? {
                        true: angular.getObjVal(carrierSetting, 'option.vtrue'),
                        false: angular.getObjVal(carrierSetting, 'option.vfalse')
                    } : null
                });
            });
            return options;
        }

        function viewRates(item) {
            Carrier.getServiceRateCards(item.id, function (data) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'full-height-modal',
                    templateUrl: '/templates/pages/carriers/RateCardPrevModal.html',
                    controller: 'RateCardPrevModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        serviceRate: function () {
                            return angular.copy(vm.serviceProfile);
                        },
                        rateType: function () {
                            return {
                                value: 'byweight'
                            };
                        }
                    }
                });
                modalInstance.result.then(function (data) {
                }, function () {
                });
            });
        }
        function exitViewMode(profile) {
            profile.viewMode = false;
        }
        function setCompany(company) {
            vm.company = company;
            $timeout(()=>{
                scrollToForm('company-profiles');
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/NetworkEffectController.js